import React from 'react'
import { Create, required, SimpleForm, TextInput, useNotify, useRedirect, useTranslate, BooleanInput } from 'react-admin'
import { Grid } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'

export const FinancialEntityCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()

  const onSuccess = () => {
    notify('ra.notification.created_success_femenine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.financial_entity') }
    })
    redirect('/financial-entity')
  }

  const onError = () => {
    notify('ra.notification.created_error_femenine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.financial_entity') }
    })
  }

  return (
    <Create {...props} mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.create_financial_entity')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.short_name')} required>
              <TextInput source='short_name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.long_name')} required>
              <TextInput source='long_name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.slug')} required>
              <TextInput source='slug' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.state')}>
              <BooleanInput label={translate('ra.field.is_active')} source='is_active' fullWidth />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
